import { CategoryId } from "@/services/collection/categories/categoriesSchema";

export const isValidCategoryId = (categoryId: number): categoryId is CategoryId => Object.values(CategoryId).includes(categoryId);
